import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateArrayService } from './translate-array.service';
import { TranslatedItem } from './translate-array.service';

@Pipe({
  name: 'translateArray'
})
export class TranslateArrayPipe implements PipeTransform {

  constructor(private service: TranslateArrayService) { }

  transform(keys: string[], prefix: string = ''): Observable<TranslatedItem[]> {
    return this.service.instant(keys, prefix)
  }
}
